<template>
  <q-page padding>
    <PageHeader
      title="Requisição Grupo"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div
      class="row col-12 text-weight-bold text-brand-5 q-mt-md q-gutter-sm container-inputs"
    >
      <div class="col-md col-xs-4">
        <div class="texto-titulo-input">Unidade</div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade.nome"
          :error="unidadeObrigatoria"
        ></lista-unidades-select>
      </div>
      <div class="col-md col-xs-3" @click.capture="verificarUnidade">
        <div class="texto-titulo-input">Grupos</div>
        <q-select
          label="Selecione o Grupo"
          dense
          outlined
          class="input-new-design"
          input-debounce="500"
          v-model="dados.grupo"
          :options="listaGrupo"
          @filter="filtrarGrupo"
          fill-input
          use-input
          hide-selected
          label-color="grey-6"
          option-label="name"
        />
      </div>
      <div
        v-if="temPermissaoCracha()"
        class="col-md col-xs-4"
        @click.capture="verificarUnidade"
      >
        <div class="texto-titulo-select">Crachá Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          debounce="500"
          :buscarPorCracha="true"
        />
      </div>
      <div class="col-md col-xs-3" @click.capture="verificarUnidade">
        <div class="texto-titulo-input">Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          @emitirFuncionario="receberFuncionario"
          :atualizarDados="atualizarUsuario"
        />
      </div>
      <div class="col-md col-xs-3" @click.capture="verificarUnidade">
        <div class="texto-titulo-input">Centro de Custo</div>
        <q-select
          label="Selecione o Centro de Custo"
          dense
          class="input-new-design"
          outlined
          label-color="grey-6"
          use-input
          behavior="menu"
          fill-input
          hide-selected
          @filter="filtrarCentroCusto"
          v-model="dados.centroCusto"
          :options="listaCentroCustos"
          :option-label="labelCustomizadaCentroCusto"
        />
      </div>
      <div class="col-md col-xs-3" @click.capture="verificarUnidade">
        <div class="texto-titulo-input">Saldo Estoque</div>
        <q-select
          v-model="saldo"
          dense
          outlined
          map-options
          emit-value
          option-value="value"
          option-label="label"
          :options="saldoOptionsFiltered"
          :disable="isSaldoSelectDisabled"
          :bg-color="isSaldoSelectDisabled ? 'brand-7' : undefined"
          class="select input-new-design"
        />
      </div>
    </div>

    <div class="col-12 q-mt-xl mobile">
      <div
        class="row justify-between text-h6 container-texto-input-search text-brand-5 text-weight-bold q-mt-lg q-mb-lg"
      >
        <span class="q-mb-md texto-titulo-tabela"
          >Selecione os Produtos para Requisição</span
        >
        <div class="input-search-table col-md-3 col-xs-12">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.produto"
            type="text"
            class="col-xs-12 col-sm-12"
            placeholder="Pesquisar Produto"
            :disable="autenticacao"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <div>
        <q-linear-progress size="xs" v-if="loading" indeterminate />
        <q-table
          grid
          :rows="listaProdutos"
          :columns="columns"
          color="primary"
          selection="multiple"
          dense
          row-key="produto_id"
          flat
          hide-pagination
          hide-bottom
          v-model:selected="selected"
          :rows-per-page-options="[0]"
        >
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col-3 q-mr-sm text-center q-mt-md">
                  <div class="img-container-grid q-ml-sm">
                    <span class="img-grid"></span>
                  </div>
                </div>
                <div class="col">
                  <q-card-section class="row text-brand-5 text-grid-table">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Código:</strong>
                        {{ props.row.produto_codigo }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Descrição:</strong>
                        {{ props.row.produto_descricao }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Categoria:</strong>
                        {{ props.row.categoria_descricao }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Endereço:</strong>
                        {{ props.row.endereco }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Preço:</strong>
                        {{ props.row.produto_preco }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Unidade:</strong>
                        {{ props.row.unidade_medida }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque:</strong>
                        {{ props.row.quantidade }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Comprometido:</strong>
                        {{ props.row.quantidade_comprometida }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Est. Min:</strong>
                        {{ props.row.quantidade_reposicao }}</span
                      >
                    </div>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div class="q-ml-md">
                              <p></p>
                              <q-btn
                                :text-color="props.selected ? 'black' : ''"
                                :color="props.selected ? 'accent' : 'primary'"
                                label="Selecionar"
                                @click="
                                  dados.centroCusto == ''
                                    ? quasar.notify({
                                        message:
                                          'Selecione um centro de custo.',
                                        color: 'negative',
                                        actions: [
                                          {
                                            label: 'fechar',
                                            color: 'white',
                                            handler: () => {
                                              /* ... */
                                            },
                                          },
                                        ],
                                      })
                                    : (props.selected = !props.selected)
                                "
                                :disable="props.selected"
                                no-caps
                                dense
                                size="11px"
                                :icon="
                                  props.selected
                                    ? 'check_circle_outline'
                                    : 'add_circle_outline'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
        </q-table>
      </div>
    </div>

    <div class="col-12 q-mt-xl desktop">
      <div
        class="row justify-between text-h6 container-texto-input-search text-brand-5 text-weight-bold q-mt-lg q-mb-lg"
      ></div>
      <q-linear-progress size="xs" v-if="loading" indeterminate />
      <div>
        <q-table
          :grid="$q.screen.lt.sm"
          :rows="listaProdutos"
          :columns="columns"
          color="primary"
          selection="multiple"
          dense
          row-key="produto_id"
          class="my-sticky-dynamic"
          flat
          hide-pagination
          hide-bottom
          v-model:selected="selected"
          :rows-per-page-options="[0]"
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Selecione os Produtos para Requisição
            </span>
          </template>
          <template v-slot:top-right>
            <div class="row">
              <div class="input-search-table">
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  v-model="filtros.produto"
                  type="text"
                  class="col-xs-12 col-sm-12"
                  placeholder="Pesquisar Produto"
                  :disable="autenticacao"
                >
                  <template v-slot:append>
                    <q-icon name="search" />
                  </template>
                </q-input>
              </div>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-btn
                  :disable="autenticacao"
                  no-caps
                  round
                  dense
                  :icon="props.selected ? 'close' : 'add'"
                  :color="props.selected ? 'red' : 'secondary'"
                  @click="
                    dados.centroCusto == ''
                      ? quasar.notify({
                          message: 'Selecione um centro de custo.',
                          color: 'negative',
                          actions: [
                            {
                              label: 'fechar',
                              color: 'white',
                              handler: () => {
                                /* ... */
                              },
                            },
                          ],
                        })
                      : (props.selected = !props.selected)
                  "
                />
              </q-td>
              <q-td>
                <span>{{ props.row.produto_codigo }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.produto_descricao }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.categoria_descricao }}</span>
              </q-td>
              <q-td
                ><span>{{ props.row.endereco }}</span></q-td
              >
              <q-td
                ><span>{{ props.row.produto_preco }}</span></q-td
              >
              <q-td>
                <span>{{ props.row.unidade_medida }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.quantidade }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.quantidade_comprometida }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.quantidade_reposicao }}</span>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>

    <div class="col-12 q-mt-xl mobile" v-if="selected.length > 0">
      <div>
        <q-table
          grid
          :rows="selected"
          color="primary"
          :columns="columns2"
          dense
          row-key="produto_id"
          flat
          hide-pagination
          :loading="loading"
          :rows-per-page-options="[0]"
          hide-bottom
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Produtos Selecionados</span
            >
          </template>
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col-3 q-mr-sm text-center q-mt-md">
                  <div class="img-container-grid q-ml-sm">
                    <span class="img-grid"></span>
                  </div>
                </div>
                <div class="col">
                  <q-card-section class="row text-brand-5 text-grid-table">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Código:</strong>
                        {{ props.row.produto_codigo }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Descrição:</strong>
                        {{ props.row.produto_descricao }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Categoria:</strong>
                        {{ props.row.categoria_descricao }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Endereço:</strong>
                        {{ props.row.endereco }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Preço:</strong>
                        {{ props.row.produto_preco }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Unidade:</strong>
                        {{ props.row.unidade_medida }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque:</strong>
                        {{ props.row.quantidade }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Comprometido:</strong>
                        {{ props.row.quantidade_comprometida }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Est. Min:</strong>
                        {{ props.row.quantidade_reposicao }}</span
                      >
                    </div>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div class="q-mr-sm">
                              <p></p>
                              <q-icon
                                name="arrow_left"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.quantidadeRequisicao != null &&
                                  props.row.quantidadeRequisicao > 0
                                    ? props.row.quantidadeRequisicao--
                                    : ''
                                "
                              />
                            </div>
                            <div
                              class="row col-2 justify-center input-quantidade-container"
                              style="border-bottom: 1px solid #505050"
                            >
                              <q-input
                                class="input-quantidade"
                                borderless
                                dense
                                type="number"
                                v-model="props.row.quantidadeRequisicao"
                                :disable="autenticacao"
                                min="0"
                              />
                            </div>
                            <div class="q-ml-sm">
                              <p></p>
                              <q-icon
                                name="arrow_right"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.quantidadeRequisicao == null ||
                                  props.row.quantidadeRequisicao == undefined
                                    ? (props.row.quantidadeRequisicao = 1)
                                    : props.row.quantidadeRequisicao++
                                "
                              />
                            </div>
                          </div>
                          <div class="row col justify-center q-ml-xl">
                            <div>
                              <p></p>
                              <q-icon
                                name="close"
                                style="
                                  font-size: 28px;
                                  margin: 0px 0px 3px 0px;
                                  cursor: pointer;
                                "
                                color="red"
                                @click="removerProduto(props.row.produto_id)"
                              ></q-icon>
                            </div>
                            <div class="q-ml-sm">
                              <p></p>
                              <q-icon
                                name="manage_search"
                                style="
                                  font-size: 28px;
                                  margin: 0px 0px 3px 0px;
                                  cursor: pointer;
                                "
                                color="black"
                                @click="
                                  (item = {
                                    nome: props.row.produto_descricao,
                                    id: props.row.produto_codigo,
                                  }),
                                    atualizarHistorico++
                                "
                              ></q-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
        </q-table>
      </div>
    </div>

    <div class="col-12 q-mt-xl desktop" v-if="selected.length > 0">
      <div>
        <q-table
          :rows="selected"
          color="primary"
          :columns="columns2"
          row-key="produto_id"
          dense
          class="tabela-tamanho-fixo"
          flat
          hide-pagination
          :loading="loading"
          :rows-per-page-options="[0]"
          hide-bottom
        >
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Produtos Selecionados</span
            >
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-btn
                  icon="close"
                  color="red"
                  dense
                  round
                  :disable="autenticacao"
                  @click="removerProduto(props.row.produto_id)"
                />
              </q-td>
              <q-td>
                <span>{{ props.row.produto_codigo }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.produto_descricao }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.categoria_descricao }}</span>
              </q-td>
              <q-td
                ><span>{{ props.row.endereco }}</span></q-td
              >
              <q-td
                ><span>{{ props.row.produto_preco }}</span></q-td
              >
              <q-td>
                <span>{{ props.row.unidade_medida }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.quantidade }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.quantidade_comprometida }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.quantidade_reposicao }}</span>
              </q-td>
              <q-td>
                <q-input
                  dense
                  outlined
                  type="number"
                  style="width: 90px"
                  v-model="props.row.quantidadeRequisicao"
                  :disable="autenticacao"
                  min="0"
                />
              </q-td>
              <q-td>
                <q-btn
                  icon="manage_search"
                  flat
                  round
                  color="black"
                  @click="
                    (item = {
                      nome: props.row.produto_descricao,
                      id: props.row.produto_codigo,
                    }),
                      atualizarHistorico++
                  "
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <div class="row col-12 q-mt-lg text-brand-5 text-weight-bold">
      <div class="col-12">
        <div
          style="font-weight: 100"
          class="q-ml-sm text-brand-1 no-margin-no-padding"
        >
          Observações
        </div>
        <q-input
          type="textarea"
          dense
          outlined
          :disable="autenticacao"
          v-model="dados.observacao"
        />
      </div>
      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'vouchers-razao-criacao'
          ) != -1
        "
        class="q-mt-lg text-brand-5 text-weight-bold"
      >
        <span
          style="font-weight: 100"
          class="row col-12 text-brand-1 texto-autenticacao"
          >Selecione o Motivo para a Solicitação dessa requisição
          <span style="color: #8a8a8a" class="q-ml-sm">(Opcional)</span></span
        >
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Perda"
          val="Perda"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Roubo"
          val="Roubo"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            !$store.state.autenticacao.cliente.includes('acciona') &&
            !$store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Desgaste Natural"
          val="Desgaste Natural"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Desgaste Precoce"
          val="Desgaste Precoce"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Possivel Defeito de Fabricação"
          val="Possivel Defeito de Fabricação"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Atividade Emergencial"
          val="Atividade Emergencial"
          :size="mobile ? 'sm' : 'lg'"
        />

        <q-radio
          v-model="dados.motivoRequisicao"
          label="Outros"
          val="Outros"
          :size="mobile ? 'sm' : 'lg'"
        />
      </div>
    </div>
    <div
      style="max-width: 70%"
      v-if="dados.motivoRequisicao == 'Outros'"
      class="column col-md-8 col-sm-6 col-xs-6"
    >
      <div class="texto-titulo-input">Digite o motivo da retirada</div>
      <q-input
        v-model="dados.motivoRequisicaoOutros"
        dense
        outlined
        class="select"
      />
    </div>

    <div class="row col-12 q-mt-lg container-btn">
      <div>
        <q-btn
          v-if="!autenticacao"
          label="Abrir Requisição"
          icon="add"
          :disable="travarBotaoRequisicao"
          style="background-color: #21324a; border-radius: 8px; color: white"
          no-caps
          @click="criarRequisicao()"
        />
      </div>
    </div>

    <TabelaHistoricoRetirada
      :solicitanteId="dados.usuario"
      :item="item"
      :atualizar="atualizarHistorico"
    />
  </q-page>
</template>

<script setup>
import { useQuasar } from "quasar";
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import TabelaHistoricoRetirada from "../components/TabelaHistoricoRetirada.vue";
import SelecaoFuncionario from "../../ferramentaria/components/SelecaoFuncionario.vue";
import { useRouter } from "vue-router";
import { watchDebounced } from "@vueuse/core";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "center",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "categoria",
    label: "Categoria",
    align: "left",
  },
  {
    name: "endereco",
    label: "Endereço",
    align: "left",
  },
  {
    name: "preco",
    label: "Preço",
    align: "left",
  },
  {
    name: "unidadeMedida",
    label: "Unidade de Medida",
    align: "left",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
  },
  {
    name: "comprometido",
    label: "Comprometido",
    align: "left",
  },
  {
    name: "estoqueMinimo",
    label: "Estoque Min",
    align: "left",
  },
];

const columns2 = [
  {
    name: "selecionar",
    label: "",
    align: "center",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "categoria",
    label: "Categoria",
    align: "left",
  },
  {
    name: "endereco",
    label: "Endereço",
    align: "left",
  },
  {
    name: "preco",
    label: "Preço",
    align: "left",
  },
  {
    name: "unidadeMedida",
    label: "Unidade de Medida",
    align: "left",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
  },
  {
    name: "comprometido",
    label: "Comprometido",
    align: "left",
  },
  {
    name: "estoqueMinimo",
    label: "Estoque Min",
    align: "left",
  },
  {
    name: "quantidade",
    label: "Quantidade",
    align: "left",
  },
  {
    name: "retiradas",
    label: "Retiradas",
    align: "left",
  },
];

const store = useStore();
const quasar = useQuasar();
const router = useRouter();

const unidadeObrigatoria = ref(false);

const unidade = ref({
  nome: store.state.org.unidadeData,
  id: store.state.org.unidadeData.id,
});
let mobile = ref(false);
if (quasar.platform.is.mobile) {
  mobile = ref(true);
}
const dados = ref({
  usuario: "",
  centroCusto: "",
  observacao: "",
  idRequisicaoGerada: "",
  solicitanteId: "",
  tipoAutenticacao: "",
  motivoRequisicao: "",
  motivoRequisicaoOutros: undefined,
  grupo: { name: "Todos", id: "" },
});
const saldo = ref("");

const temPermissaoComSaldo = computed(() => {
  return (
    store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
      "voucher-mostrar-com-saldo"
    ) || false
  );
});

const temPermissaoSemSaldo = computed(() => {
  return (
    store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
      "voucher-mostrar-sem-saldo"
    ) || false
  );
});

const isSaldoSelectDisabled = computed(() => {
  return temPermissaoComSaldo.value || temPermissaoSemSaldo.value;
});

const saldoOptionsFiltered = computed(() => {
  if (temPermissaoComSaldo.value) {
    return [{ label: "Com Saldo", value: "com-saldo" }];
  }
  if (temPermissaoSemSaldo.value) {
    return [{ label: "Sem Saldo", value: "sem-saldo" }];
  }
  return [
    { label: "Todos", value: "" },
    { label: "Com Saldo", value: "com-saldo" },
    { label: "Sem Saldo", value: "sem-saldo" },
  ];
});

const inicializarSaldoBasedoNasPermissoes = () => {
  if (temPermissaoComSaldo.value) {
    saldo.value = "com-saldo";
  } else if (temPermissaoSemSaldo.value) {
    saldo.value = "sem-saldo";
  } else {
    saldo.value =
      store.state.autenticacao.cliente.includes("acciona") ||
      store.state.autenticacao.cliente.includes("staging-acciona")
        ? "com-saldo"
        : "";
  }
};

const filtros = ref({
  usuario: "",
  centroCusto: "",
  grupo: "",
  produto: "",
});
let loadingInnerCentroCusto = ref(false);
const solicitanteMatricula = ref(null);
const solicitantePesquisa = ref(null);
const centroCustoUsuario = ref(null);
const listaCentroCustos = ref([]);
const listaProdutos = ref([]);
const selected = ref([]);
let autenticacao = ref(false);
let loading = ref(false);
let atualizarUsuario = ref(0);
const listaGrupo = ref([]);
const item = ref({ nome: "", id: "" });
const listarTodos = ref(true);
const travarBotaoRequisicao = ref(false);
const atualizarHistorico = ref(0);
const crachaSolicitante = ref(null);

const listarCentroCustos = async (val) => {
  await store.state.autenticacao.cliente;
  await store.state.org.unidadeData.id;
  try {
    loadingInnerCentroCusto.value = true;
    const response = await store.dispatch("requisicao/listarCentrosCustos", {
      per_page: 10,
      vendor_id: store.state.org.unidadeData.id,
      search: val,
    });
    listaCentroCustos.value = response.data.results.data;
    loadingInnerCentroCusto.value = false;
  } catch (error) {
    console.log(error);
  }
};

const listarProdutos = async () => {
  if (dados.value.grupo === "") {
    return;
  }
  if (dados.value.usuario?.id === "" || dados.value.usuario?.id == undefined) {
    return;
  }
  try {
    loading.value = true;
    const response = await store.dispatch(
      "requisicao/listarProdutosListagemSimplificada",
      {
        vendor_id: unidade.value.id,
        produto: filtros.value.produto,
        grupo_id: dados.value.grupo?.id,
        per_page: 100,
        saldo: saldo.value == "" ? undefined : saldo.value,
      }
    );

    listaProdutos.value = response.data.data;
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const criarRequisicao = async () => {
  if (
    unidade.value.id == "218" &&
    (store.state.autenticacao.cliente[0] == "staging-vale" ||
      store.state.autenticacao.cliente[0] == "vale-epiexpress")
  ) {
    quasar.notify({
      message: "Selecione outro posto para a criação da requisição",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }

  if (
    unidade.value.id == "1" &&
    (store.state.autenticacao.cliente[0] == "cbmsa" ||
      store.state.autenticacao.cliente[0] == "staging-cbmsa")
  ) {
    quasar.notify({
      message: "Selecione outro posto para a criação da requisição",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (dados.value.usuario?.id === "" || dados.value.usuario?.id == undefined) {
    quasar.notify({
      message: "Selecione um solicitante.",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (dados.value.centroCusto === "" || dados.value.centroCusto == undefined) {
    quasar.notify({
      message: "Selecione um centro de custo.",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (selected.value.length == 0) {
    quasar.notify({
      message: "Selecione ao menos um item.",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  let produtos = [];
  selected.value.forEach((produto) => {
    let array = [];
    array = Object.keys(produto);
    let existe = array.some((value) => value == "quantidadeRequisicao");
    if (!existe || produto.quantidadeRequisicao <= 0) {
      quasar.notify({
        message: `O item ${produto.produto_descricao} está com quantidade zerada, altere a quantidade ou remova o item para seguir!`,
        color: "negative",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      return;
    }
    produtos.push({
      amount: parseFloat(produto.quantidadeRequisicao),
      categoria_codigo: produto.categoria_codigo,
      categoria_descricao: produto.categoria_descricao,
      categoria_id: produto.categoria_id,
      endereco: produto.endereco,
      grupo_id: produto.grupo_id,
      id: produto.produto_id,
      grupo_nome: produto.grupo_nome,
      produto_codigo: produto.produto_codigo,
      produto_descricao: produto.produto_descricao,
      produto_id: produto.produto_id,
      produto_preco: produto.produto_preco,
      quantidade: produto.quantidade,
      quantidade_comprometida: produto.quantidade_comprometida,
      quantidade_reposicao: produto.quantidade_reposicao,
      unidade_medida: produto.unidade_medida,
      unidade_medida_descricao: produto.unidade_medida_descricao,
    });
  });
  if (selected.value.length != produtos.length) {
    return;
  }
  travarBotaoRequisicao.value = true;
  if (unidade.value.id == undefined || unidade.value.id == "") {
    travarBotaoRequisicao.value = false;
    quasar.notify({
      message: "Selecione uma Unidade para criar a Requisição.",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  try {
    const response = await store.dispatch("requisicao/criarRequisicao", {
      cost_center_id: dados.value.centroCusto.id,
      description: dados.value.observacao || undefined,
      plantiff_id: dados.value.usuario?.idTabela,
      products: produtos,
      vendor_id: unidade.value.id,
      voucher_reason:
        dados.value.motivoRequisicao != ""
          ? dados.value.motivoRequisicao == "Outros"
            ? dados.value.motivoRequisicaoOutros
            : dados.value.motivoRequisicao
          : undefined,
    });
    quasar.notify({
      message:
        "Voucher criado com sucesso! Ele está como rascunho, você deve entrar na listagem de vouchers e envia-lo para aprovação para dar sequência a retirada dos itens.",
      color: "positive",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    dados.value.idRequisicaoGerada = response.data.model.id;
    dados.value.solicitanteId = response.data.model.plantiff_id;
    router.push({
      name: "requisicao-lista",
    });
  } catch (error) {
    travarBotaoRequisicao.value = false;
    quasar.notify({
      message: "Erro ao criar voucher",
      color: "negative",
      actions: [
        {
          label: "fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const listarGrupo = async (search) => {
  try {
    const response = await store.dispatch("requisicao/listarGrupos", {
      per_page: 10,
      vendor_id: store.state.org.unidadeData.id,
      search: search,
    });
    listaGrupo.value = response.data.results.data;
    if (search == "" || search == undefined) {
      listaGrupo.value.unshift({ name: "Todos", id: "" });
    }
  } catch (error) {
    console.log(error);
  }
};

const removerProduto = (produto_id) => {
  selected.value = selected.value.filter(
    (produto) => produto.produto_id != produto_id
  );
};

const receberFuncionario = (value) => {
  dados.value.usuario = value;
};

const receberFuncionarioPorCracha = (value) => {
  solicitanteMatricula.value = value;
  solicitantePesquisa.value = value?.nome;

  dados.value.usuario = value;

  centroCustoUsuario.value = `${value.centroCustoCode} - ${value.centroCustoName}`;
};

const labelCustomizadaCentroCusto = (value) => {
  if (value === "") {
    return "";
  }
  return `${value.code} - ${value.name}`;
};

const temPermissaoCracha = () => {
  return (
    store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
      "voucher-auth-cracha"
    ) || false
  );
};

watch(
  () => unidade.value.nome,
  (novoValor) => {
    if (novoValor?.id) {
      unidadeObrigatoria.value = false;
    }
  }
);

const verificarUnidade = (event) => {
  if (!unidade.value?.nome?.id) {
    event.stopPropagation();
    event.preventDefault();
    unidadeObrigatoria.value = true;
    quasar.notify({
      message: "O campo Unidade é obrigatório para seguir com a requisição",
      color: "negative",
      position: "bottom",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {},
        },
      ],
    });
  }
};

watch(
  () => store.state.org.unidadeData.id,
  () => {
    if (store.state.org.unidadeData == null) {
      return;
    }
    unidade.value.nome = store.state.org.unidadeData;
    unidade.value.id = store.state.org.unidadeData.id;
  }
);

watch(
  () => listarTodos.value,
  () => {
    listarProdutos();
  }
);

function filtrarCentroCusto(val, update) {
  listarCentroCustos(val);
  setTimeout(() => {
    update();
  }, 500);
}

function filtrarGrupo(val, update) {
  listarGrupo(val);
  setTimeout(() => {
    update();
  }, 500);
}

watch(
  () => dados.value.usuario,
  () => {
    listarProdutos();
  }
);

watch(
  () => filtros.value.grupo,
  () => {
    listarGrupo();
  }
);

watch(
  () => filtros.value.centroCusto,
  () => {
    listarCentroCustos();
  }
);

watchDebounced(
  () => filtros.value.produto,
  () => {
    listarProdutos();
  },
  { debounce: 1000 }
);

watch(
  () => dados.value.grupo,
  () => {
    listarProdutos();
  }
);

onMounted(() => {
  listarGrupo();
  listarCentroCustos();
  inicializarSaldoBasedoNasPermissoes();
});
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.texto-titulo-tabela {
  font-size: 18px;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
thead tr th {
  white-space: pre-wrap;
}
tbody tr td {
  white-space: pre-wrap;
}
.texto-toggle {
  font-size: 14px;
}

@media (min-width: 601px) {
  .mobile {
    display: none !important;
  }
  .desktop {
    display: block !important;
  }
}

@media (max-width: 600px) {
  .desktop {
    display: none !important;
  }
  .mobile {
    display: block !important;
  }
  .my-sticky-dynamic {
    max-height: 1000px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .card {
    border: 1px solid #a8b3c9;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  .btn-grid-container {
    padding: 0;
    margin: 0;
  }
  .img-container-grid {
    border: 2px solid #b4b4b4;
    border-radius: 5px;
    font-weight: bold;
    width: 90px;
    height: 110px;
  }
  .img-grid {
    max-width: 100%;
    height: 100%;
  }
  .input-quantidade {
    margin: 0px;
    padding-left: 11px;
    font-size: 14px;
  }
  .input-quantidade-container {
    margin: 0px 0px 0px 0px;
    padding: 0px;
    height: 32px;
  }
  .arrow {
    font-size: 20px;
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
    margin: 0px 3px 0px 3px;
    color: white;
  }

  .secao-final-garantida {
    position: relative !important;
    z-index: 10 !important;
    background-color: white !important;
    width: 100% !important;
    margin-top: 40px !important;
    padding: 20px 0 !important;
    border-top: 2px solid #e0e0e0 !important;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1) !important;
    clear: both !important;
  }

  .secao-final-garantida::before {
    content: "";
    display: block;
    clear: both;
    height: 1px;
  }

  .q-table--grid .q-table__grid-content {
    display: flex !important;
    flex-wrap: wrap !important;
    width: 100% !important;
    overflow: hidden !important;
    margin-bottom: 0 !important;
  }

  .q-table--grid .q-table__grid-item {
    width: 100% !important;
    margin-bottom: 16px !important;
    clear: both !important;
  }

  .col-12.q-mt-xl:last-of-type {
    margin-bottom: 30px !important;
  }

  @media only screen and (max-width: 368px) {
    .input-quantidade-container {
      width: 40px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
  }

  .container-inputs {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .col-md {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
  }

  .texto-titulo-input,
  .texto-titulo-select {
    font-size: 12px !important;
    margin-bottom: 4px;
  }

  .input-new-design {
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .no-margin-no-padding {
    padding: 0;
    margin: 0;
  }

  .motivo-container {
    width: 100% !important;
    margin-top: 20px;
    padding: 0;
  }

  .radio-container {
    flex-direction: column !important;
  }

  .radio-container .q-radio {
    margin-bottom: 12px;
  }

  .texto-autenticacao {
    font-size: 14px !important;
  }

  .container-btn {
    justify-content: center !important;
    margin-top: 20px;
  }
}

@media only screen and (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .texto-autenticacao {
    font-size: 13px !important;
  }

  .q-page {
    padding: 8px !important;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
